__turbopack_context__.v({
  "active": "billing-toggle-module-scss-module__J7V4IG__active",
  "badge": "billing-toggle-module-scss-module__J7V4IG__badge",
  "button": "billing-toggle-module-scss-module__J7V4IG__button",
  "button_label": "billing-toggle-module-scss-module__J7V4IG__button_label",
  "buttons": "billing-toggle-module-scss-module__J7V4IG__buttons",
  "hint": "billing-toggle-module-scss-module__J7V4IG__hint",
  "root": "billing-toggle-module-scss-module__J7V4IG__root",
});
